import { GenerateWeightedEquityValueExpressionParams } from './types';

const generateWeightedEquityValueExpression = (params: GenerateWeightedEquityValueExpressionParams) => {
  const { columnLegend, scenarioEquityValueRowNumber } = params;

  return `(${columnLegend}${scenarioEquityValueRowNumber} * ${columnLegend}${scenarioEquityValueRowNumber + 1})`;
};

export default generateWeightedEquityValueExpression;
